define('gigaset_contentbridge/components/contact-form',[
	"jquery",
	"cartware/components/_base"
], function(
	$,
	Component
) {
	return Component.create({
		$init: function() {
			// Handle contact form submissions and category and sub-category relations
			$('.contact-form').each(function () {

				var $form = $(this),
					$categories = $form.find('.contact-categories'),
					$subCategories = $form.find('.contact-subcategories'),
					hasBothSelects = $categories.length > 0 && $subCategories.length > 0,
					hiddenClass = 'hidden',
					activeClass = 'dk_option_current';

				// Validate submission
				$form.submit(function () {

					var $allFields = $form.find('input, textarea, select'),
						$allCustomSelects = $form.find('.dk_container'),
						$requiredField = $form.find('.required-entry'),
						errorCount = 0;

					// Reset all failed fields
					$allFields.removeClass('validation-failed');
					// Reset all failed custom selects
					$allCustomSelects.removeClass('validation-failed');

					$requiredField.each(function () {

						var $thisField = $(this),
							isSelectElement = $thisField.is("select"),
							isEmailElement = $thisField.attr("type") == "email",
							expr = /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/i;

						if (isSelectElement) {

							if ($thisField.val() == "VOID") {

								var identifier = $thisField.attr('data-identifier'),
									$customSelect = $form.find('#dk_container_' + identifier);

								if ($customSelect.length > 0) {

									$customSelect.addClass('validation-failed');
								}

								errorCount++;
							}
						} else if (isEmailElement) {

							if ($thisField.val() == "" || !expr.test($thisField.val())) {

								$thisField.addClass('validation-failed');
								errorCount++;
							}
						} else {

							if ($thisField.val() == "") {

								$thisField.addClass('validation-failed');
								errorCount++;
							}
						}

					});

					return errorCount == 0;
				});


				if (hasBothSelects) {

					// When $categories is changed, show corresponding optgroup within custom dropdown representing $subCategories
					$categories.on('change', function () {

						// Reset subcategories to first option
						$subCategories.find('option:first').attr('selected','selected');

						var $self = $(this),
							activeCategory = $self.val(),
							$activeSubCategory = $subCategories.find('option:selected'),
							activeSubCategoryText = $activeSubCategory.text(),
							$customMenu = $subCategories.siblings('.dk_container'),
							$customMenuActiveCategory = $customMenu.find('[data-dk-dropdown-value="' + activeSubCategoryText + '"]').parent('li');

						if ($customMenu.length) {

							$customMenu
								// Show/hide relevant subcategories
								.find('li[class^="cat-"]')
								.addClass(hiddenClass)
								.end()
								.find('.cat-' + activeCategory)
								.removeClass(hiddenClass)
								.end()
								// Update label
								.find('.dk_label')
								.text(activeSubCategoryText)
								.end()
								// Hide previously selected subcategory
								.find('.' + activeClass)
								.removeClass(activeClass)
								.end();

							// Set first subcategory as selected (style-wise)
							$customMenuActiveCategory.addClass(activeClass);
						}
					});
				}
			});
		}
	});
});
